/* eslint-disable */
import RegisterDrawerComponent from 'frontastic/tastics/registerDrawer';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import AuthForm from '../layouts/auth-form';
import Input from 'components/commercetools-ui/atoms/input';
import PasswordInput from 'components/commercetools-ui/atoms/input-password';
import useTranslation from 'providers/i18n/hooks/useTranslation';
import { sdk } from 'sdk';
import useAuthProps from './hooks/useAuthProps';
import { useRouter, useSearchParams } from 'next/navigation';
import LoginPopup from '../login/login-popup';
import { EMAIL_PATTERN } from '../company-registration/data';
import { REGISTRATION } from 'helpers/constants/events';

type ChangeHandler = (event: ChangeEvent<HTMLInputElement>) => void;

const RegisterPopup: FC<any> = ({
  showPopup,
  setShowPopup,
  defaultLoginModal = false,
  handleModalCancel,
  showLogin = false,
  error_description = '',
}) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  let searchCode = searchParams.get('code');
  let searchSupportSignUp = searchParams.get('supportSignUp');
  let searchSuccess = searchParams.get('success');
  let searchMessage = searchParams.get('message')?.replace(/\+/g, ' ').toLowerCase();

  const { translate } = useTranslation();
  const extensions = sdk.composableCommerce;

  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [accountCreated, setAccountCreated] = useState(false);
  const [bootLogin, setBootLogin] = useState(defaultLoginModal);
  const [data, setData] = useState<any>({});
  const [failed, setFailed] = useState('');

  const inputArray = [
    { label: translate('common.emailAddress'), name: 'email' },
    // { label: translate('common.firstName'), name: 'firstName' },
    // { label: translate('common.lastName'), name: 'lastName' },
  ];

  useEffect(() => {
    if (showLogin === true) {
      setBootLogin(true);
    }
  }, [showLogin]);

  const handleBlur = () => {
    const emailRegex = EMAIL_PATTERN;
    if (!data.email || !emailRegex.test(data.email)) {
      setError(translate('error.auth.email.wrong'));
    } else {
      setError('');
    }
  };
  const handlePwdBlur = () => {
    const capitalRegex = /[A-Z]/;
    const specialCharRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
    const numberRegex = /[0-9]/;

    if (
      !data.password ||
      data.password.length < 8 ||
      !capitalRegex.test(data.password) ||
      !specialCharRegex.test(data.password) ||
      !numberRegex.test(data.password)
    ) {
      setError(translate('error.auth.password.wrong'));
    } else {
      setError('');
    }
  };

  const handleConfirmPwdBlur = () => {
    const capitalRegex = /[A-Z]/;
    const specialCharRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
    const numberRegex = /[0-9]/;

    if (
      !data.confirmPassword ||
      data.confirmPassword.length < 8 ||
      !capitalRegex.test(data.confirmPassword) ||
      !specialCharRegex.test(data.confirmPassword) ||
      !numberRegex.test(data.confirmPassword)
    ) {
      setError(translate('error.auth.password.wrong'));
    } else {
      setError('');
    }
  };

  const handleSubmit = async () => {
    const capitalRegex = /[A-Z]/;
    const specialCharRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
    const numberRegex = /[0-9]/;

    if (!data.email || !data.password || !data.confirmPassword) {
      setError(translate('error.auth.wrong.details'));
      return;
    }

    if (
      !data.password ||
      data.password.length < 8 ||
      !capitalRegex.test(data.password) ||
      !specialCharRegex.test(data.password) ||
      !numberRegex.test(data.password)
    ) {
      setError(translate('error.auth.password.wrong'));
      return;
    }
    if (data.confirmPassword !== data.password) {
      setError(translate('error.password.notConfirmed'));
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
      setError(translate('error.auth.email.wrong'));
      return;
    }
    if (data.email && data.password) {
      const encodedPassword = Buffer.from(data.password).toString('base64');
      const email = data.email.toLowerCase();
      const requestBody = {
        Username: email,
        Password: encodedPassword,
        ConfirmPassword: encodedPassword,
        website: 'Specify',
        stores: ['specify-au', 'specify-nz'],
      };
      setLoading(true);
      try {
        const responseBody = await extensions.account.handleRegisterSubmit(JSON.stringify(requestBody));
        if (!!responseBody?.isError) {
          setLoading(false);
          if (responseBody?.error?.message.toLowerCase() === 'failed to fetch') {
            setError(translate('error.no.internet'));
          } else {
            setError(responseBody?.error?.message);
          }
        }
        
        if (responseBody?.data?.status === 200 || responseBody?.data?.status === 'OK') {
          const encodedEmail = encodeURIComponent(email);
          if(typeof window !== 'undefined'){
            (window as any).dataLayer = (window as any).dataLayer || [];
            (window as any).dataLayer.push({
              event: REGISTRATION,
              email: email,
              status: 'success',
            });
          }
          router.push(`/verify?email=${encodedEmail}`);
          setLoading(false);
        } else if (responseBody?.data?.status === 400 || responseBody?.data?.data?.status === 400) {
          setLoading(false);
          setError(responseBody?.data?.data?.details?.errorMessage || responseBody?.data?.data?.message);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error('Registration Error:', error);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleRedirect = () => {
    // to be done - open login popup
  };
  const handleOnClosePopup = () => {
    setBootLogin(false);
    setShowPopup(false);
    setData({});
    setError('');
    setAccountCreated(false);
    if (handleModalCancel) {
      handleModalCancel();
    }
  };
  const authProps = useAuthProps({
    handleSubmitRegister: handleSubmit,
    handleLoginRedirect: handleRedirect,
    handleBootLogin: () => setBootLogin(true),
    handleOnClosePopup,
  });

  const handleChange = (name: string, value: string) => {
    if (name === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value || !emailRegex.test(value)) {
        setError(translate('error.auth.email.wrong'));
      } else {
        setError('');
      }
    }
    if (name === 'password' || name === 'confirmPassword') {
      const capitalRegex = /[A-Z]/;
      const specialCharRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
      const numberRegex = /[0-9]/;

      if (
        !value ||
        value.length < 8 ||
        !capitalRegex.test(value) ||
        !specialCharRegex.test(value) ||
        !numberRegex.test(value)
      ) {
        setError(translate('error.auth.password.wrong'));
      } else {
        setError('');
      }
    }
    setData((prevData: any) => ({ ...prevData, [name]: value }));
  };

  const handleInputChange: ChangeHandler = (event) => {
    const { name, value } = event.target;
    handleChange(name, value);
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSubmit();
    }
  };

  useEffect(() => {
    if (searchCode === 'success' && searchSuccess === 'true' && searchSupportSignUp === 'true') {
      setBootLogin(true);
      setShowPopup(true);
      setAccountCreated(true);
    }
    if (searchSuccess === 'false' && searchMessage === 'this url can be used only once') {
      setBootLogin(true);
      setShowPopup(true);
      setFailed(translate('error.link.already.used'));
    }
    if (searchSuccess === 'false' && searchMessage === 'access expired.') {
      setBootLogin(true);
      setShowPopup(true);
      setFailed(translate('error.link.expired'));
    }
  }, [searchParams]);

  return (
    <div>
      <RegisterDrawerComponent isOpen={showPopup}>
        {bootLogin ? (
          <LoginPopup
            error_description={error_description}
            showPopup={showPopup}
            setShowPopup={setShowPopup}
            setBootLogin={setBootLogin}
            error={error}
            failed={failed}
            loading={loading}
            handleOnClosePopup={handleOnClosePopup}
            success={accountCreated}
            setAccountCreated={setAccountCreated}
            handleModalCancel={handleModalCancel}
            defaultLoginModal={defaultLoginModal}
          />
        ) : (
          <AuthForm {...authProps} error={error} loading={loading}>
            <>
              {inputArray.map(({ label, name }) => (
                <Input
                  key={name}
                  name={name}
                  placeholder={translate('common.emailAddress')}
                  value={(data[name] as string) ?? ''}
                  required
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  // onPaste={handlePaste}
                  onKeyDown={handleKeyDown}
                  tabIndex={0}
                  className={`${error ? '!border-red-500' : '!border-[#A7A7A7]'} !rounded-[6px] `}
                />
              ))}
              <div>
                <PasswordInput
                  name="password"
                  value={data.password ?? ''}
                  className={`${error ? '!border-red-500' : '!border-[#A7A7A7]'} !rounded-[6px] !pr-28`}
                  placeholder={translate('account.password.new')}
                  onChange={handleInputChange}
                  onBlur={handlePwdBlur}
                  onKeyDown={handleKeyDown}
                  tabIndex={0}
                />
              </div>
              <div>
                <PasswordInput
                  name="confirmPassword"
                  value={data.confirmPassword ?? ''}
                  className={`${error ? '!border-red-500' : '!border-[#A7A7A7]'} !rounded-[6px] !pr-28`}
                  placeholder={translate('account.password.confirm')}
                  onChange={handleInputChange}
                  onBlur={handleConfirmPwdBlur}
                  onKeyDown={handleKeyDown}
                  tabIndex={0}
                />
              </div>
            </>
          </AuthForm>
        )}
      </RegisterDrawerComponent>
    </div>
  );
};

export default RegisterPopup;
